import { queryClient } from '@/common/contexts/react-query/ReactQueryProvider';
import {
  createPaymentIntent,
  getPaymentMethods,
} from '@/common/integrations/menhir/employee/payments/payments.service';
import { IEmployeePaymentMethod } from '@/common/integrations/menhir/employee/payments/payments.types';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from '@tanstack/react-query';

export function useGetPaymentMethods(
  options?: UseQueryOptions<IEmployeePaymentMethod[], any>
) {
  const { data: paymentMethods, ...rest } = useQuery({
    queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.PAYMENTS.METHODS.ROOT],
    queryFn: getPaymentMethods,
    ...options,
  });

  return { paymentMethods, ...rest };
}

export function useCreatePaymentIntent(
  options?: UseMutationOptions<
    Awaited<ReturnType<typeof createPaymentIntent>>,
    any,
    Parameters<typeof createPaymentIntent>[0]
  >
) {
  return useMutation({
    mutationFn: createPaymentIntent,
    ...options,
  });
}

export function setPaymentMethodsQueryData(data: IEmployeePaymentMethod[]) {
  return queryClient.setQueryData(
    [MENHIR_ENDPOINTS.EMPLOYEE.PAYMENTS.METHODS.ROOT],
    data
  );
}
